import type { IUser, IUserPreferences } from "src/model/model";

export const getReleaseOptIn = (u?: IUser): boolean => {
  const pref = u?.preferences;
  if (!pref) return false;
  try {
    const obj = typeof pref === "string" ? (JSON.parse(pref) as IUserPreferences) : pref;
    return !!obj?.wantToReceiveEmailAboutReleases;
  } catch {
    return false;
  }
};

export const getAnalyticsOptOut = (u?: IUser): boolean => {
  const pref = u?.preferences;
  if (!pref) return false;
  try {
    const obj = typeof pref === "string" ? (JSON.parse(pref) as IUserPreferences) : pref;
    return obj?.analytics_opt_out === true;
  } catch {
    return false;
  }
};
